export const reloadIframes = () => {
    const iframe = document.getElementById('iframe-id');
    if (iframe) {
        iframe.src = iframe.src;
    }
}